/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forced_Update_Exit_PreviewInputs */

const en_mobile_forced_update_exit_preview = /** @type {(inputs: Mobile_Forced_Update_Exit_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit preview`)
};

const es_mobile_forced_update_exit_preview = /** @type {(inputs: Mobile_Forced_Update_Exit_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de la vista previa`)
};

/**
* | output |
* | --- |
* | "Exit preview" |
*
* @param {Mobile_Forced_Update_Exit_PreviewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forced_update_exit_preview = /** @type {((inputs?: Mobile_Forced_Update_Exit_PreviewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forced_Update_Exit_PreviewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forced_update_exit_preview(inputs)
	return en_mobile_forced_update_exit_preview(inputs)
});